import { Ng2StateDeclaration } from "@uirouter/angular";
import { Ng1StateDeclaration, StateParams } from "@uirouter/angularjs";
import { modal } from "@gtmhub/core/routing";
import { attachNg1StateDependency, featureAvailable, featureToggleEnabled } from "@gtmhub/resolve-guards";
import { resolveModalTemplate } from "@gtmhub/shared/components/modal/template";
import { drawer } from "@webapp/core/routing/utils/drawer.routing.utils";
import { ModuleFlag } from "@webapp/feature-toggles/models/feature-module.models";
import { KpiCommentComponent } from "@webapp/kpis/components/kpi-comments/kpi-comment/kpi-comment.component";
import { KpiCommentsComponent } from "@webapp/kpis/components/kpi-comments/kpi-comments/kpi-comments.component";
import { KpiDetailsComponent } from "@webapp/kpis/components/kpi-details/kpi-details.component";

resolveModalTemplate("kpi-form", { template: require("./views/form.html") });

const abstractKpiFormState = (name: string): Ng1StateDeclaration =>
  modal({
    name,
    view: "kpiform",
    windowClass: "kpi-modal medium-x-large",
    backdropClass: "dark-backdrop",
    abstract: true,
  });

const editKpiFormState = (args: Pick<Ng1StateDeclaration, "url" | "name">): Ng1StateDeclaration => ({
  name: args.name,
  url: args.url,
  data: {
    requiresLogin: true,
    trackingPage: "KPI Details",
  },
  views: {
    "kpiform@": {
      template: require("./views/form.html"),
      controller: "KpiFormCtrl",
    },
  },
  resolve: {
    formData: [
      "$stateParams",
      ($stateParams: StateParams) => {
        return {
          kpiId: $stateParams.kpiId,
          groupId: $stateParams.groupId,
        };
      },
    ],
  },
});

export const kpiDetailsStates = (base: string): (Ng1StateDeclaration | Ng2StateDeclaration)[] => [
  drawer({
    name: `${base}.details`,
    url: ":kpiId/details/?groupId",
    data: {
      requiresLogin: true,
      trackingPage: "KPI Details And Projections",
    },
    component: KpiDetailsComponent,
    mask: false,
    size: "large",
    returnTo: "parent",
  }),
  abstractKpiFormState(`${base}.details._singleKpi`),
  editKpiFormState({ name: `${base}.details._singleKpi.form`, url: "edit/" }),

  // comments
  {
    name: `${base}.details.comments`,
    data: {
      requiresLogin: true,
      trackingPage: "KPI Comments",
    },
    url: "comments/",
    component: KpiCommentsComponent,
  },
  abstractKpiFormState(`${base}.details.comments._singleKpi`),
  editKpiFormState({ name: `${base}.details.comments._singleKpi.form`, url: "edit/" }),
  {
    name: `${base}.details.comment`,
    data: {
      requiresLogin: true,
      trackingPage: "KPI Comment",
    },
    url: ":commentId/comment/",
    component: KpiCommentComponent,
  },
  abstractKpiFormState(`${base}.details.comment._singleKpi`),
  editKpiFormState({ name: `${base}.details.comment._singleKpi.form`, url: "edit/" }),
];

export const states: (Ng1StateDeclaration | Ng2StateDeclaration)[] = [
  attachNg1StateDependency(
    {
      name: "gtmhub.kpis",
      params: {
        kpiGroupId: null,
      },
      data: {
        requiresLogin: true,
        titleKey: "kpis",
        trackingPage: "KPIs",
        pageBackgroundColor: "#fff",
      },
      url: "/kpis/?kpiGroupId",
      template: require("./views/kpis.html"),
      controller: "KpisCtrl",
    },

    featureAvailable("kpis"),
    featureToggleEnabled(ModuleFlag.Kpis)
  ),
  abstractKpiFormState("gtmhub.kpis._singleKpi"),
  {
    name: "gtmhub.kpis._singleKpi.new",
    url: "new/",
    data: {
      requiresLogin: true,
      trackingPage: "New KPI",
    },
    views: {
      "kpiform@": {
        template: require("./views/form.html"),
        controller: "KpiFormCtrl",
      },
    },
    resolve: {
      formData: () => ({}),
    },
  },
  editKpiFormState({ name: "gtmhub.kpis._singleKpi.form", url: ":kpiId/edit/?groupId" }),
  ...kpiDetailsStates("gtmhub.kpis"),
];
